import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './tag.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Tag } from "model/customerCore/tag.model";

export interface TagDetailsProps extends DetailsStateAndDispatchProps<Tag>,
  RouteComponentProps, StateProps, DispatchProps {
}

const TagDetails: FC<TagDetailsProps> = (props: any) => {

  return (
    <DetailsPage<Tag>
      title='会员详情'
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Tag>
        column={2}
        columns={props.columns}
        dataSource={props.entity}
      />
    </DetailsPage>);
};

const mapStateToProps = ({ tag }: RootState) => ({
  entity: tag.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(TagDetails);
